import { combineReducers } from "redux";
import app from "./AppReducer";
import reset from "./ResetPageReducer";
import footer from "./FooterReducers";
import events from "./EventReducers";
import eventverification from "./EventVerificationReducers";
import header from "./HeaderReducers";
import venue from "./VenueReducers";
import realevents from "./RealEventReducers";
import newleadform from "./LeadReducers";
import venueexperts from "./VenueExpertReducers";
import blog from "./BlogReducers";
import leads from "./LeadReducers";
import leadForm from "./LeadFormReducer";
import vendor from "./VendorReducers";
import photographers from "./PhotographerReducers";

const rootReducer = combineReducers({
  app,
  reset,
  footer,
  events,
  eventverification,
  header,
  venue,
  leads,
  realevents,
  newleadform,
  venueexperts,
  blog,
  leadForm,
  vendor,
  photographers,
});

export default rootReducer;
